import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { bindPopover, bindTrigger } from 'material-ui-popup-state';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PopupState from 'material-ui-popup-state';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/material/Tooltip';
import { translate } from '../../../config/lang';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { connect } from 'trim-redux';
import { makeStyles } from '@mui/styles';
import { Styles } from '../../../config/design/styles';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(Styles);

const GetConfirmationButton = ({ children, question, size, icon, color,iconColor, tooltip, handleAction }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
                <div className="floated-delete-button">
                    <Tooltip title={tooltip} arrow>
                        <IconButton color={iconColor} size={size || "medium"} {...bindTrigger(popupState)}>
                            {children}
                        </IconButton>
                    </Tooltip>
                    <Popover
                        elevation={1}
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <Box p={1}>
                            <Typography className={classes.condir}>
                                {question || t('areYouSure')}
                                <Button
                                    className={classes.confirmationButtonButton}
                                    style={{ color: color || "#f44336" }}
                                    startIcon={icon || <DeleteRoundedIcon />}
                                    onClick={() => {
                                        handleAction();
                                        popupState.close();  // Close the popover
                                    }}
                                >
                                    {t('yes')}
                                </Button>
                            </Typography>
                        </Box>
                    </Popover>
                </div>
            )}
        </PopupState>
    );
};

export default connect()(GetConfirmationButton);
